import {
  addDays,
  format,
  getMonth,
  isLastDayOfMonth,
  lastDayOfMonth,
  subDays,
  subMonths,
} from 'date-fns'

import { type Cycle } from '../../core/components/DateNavigator/cycleUtils'

const MINIMUM_SCREEN_SIZE = 900

export const formatBottomAxisDate = (cycle: Cycle, date: Date, windowWidth: number) => {
  switch (cycle) {
    case 'daily': {
      return format(date, 'MMM dd')
    }

    case 'weekly': {
      const startRangeDate = subDays(date, 6)

      return format(startRangeDate, 'MMM dd')
    }

    case 'quarterly': {
      const startRangeDate = isLastDayOfMonth(date)
        ? addDays(lastDayOfMonth(subMonths(date, 3)), 1)
        : addDays(subMonths(date, 3), 1)

      return `${format(startRangeDate, 'MMM yy')} - ${format(date, 'MMM yy')}`
    }

    case 'monthly': {
      // TODO: Replace those calculations with start+end range dates.
      const startRangeDate = isLastDayOfMonth(date)
        ? addDays(lastDayOfMonth(subMonths(date, 1)), 1)
        : addDays(subMonths(date, 1), 1)

      const formattedMonth = format(
        startRangeDate,
        getMonth(startRangeDate) === 0 ? 'MMM yy' : 'MMM'
      )

      return windowWidth < MINIMUM_SCREEN_SIZE ? formattedMonth.charAt(0) : formattedMonth
    }
  }
}
